import { LangMap } from '@pyg-services/language/language.types';

export enum META_TRANSLATIONS {
  '' = 'default',
  'blog' = 'blog',
  'futureoftelco' = 'fot',
  'pygmalios-for-frontline-teams' = 'pygx',
  'privacy-policy' = 'pp',
  'virtual-queue' = 'vq',
  'museums' = 'museums',
  'customer-journey-analytics-and-service-monitoring-with-tdi' = 'tdi',
  'ai-theft-protection' = 'shopguard',
  'in-store-analytics' = 'products',
  'contact_us' = 'contact',
}

export type ImageMetaMapType = LangMap<
  Partial<Record<META_TRANSLATIONS, string>>
>;
